import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ConfigEntityService } from "../../../core/services/config-entity.service";
import { AddNewCredentialComponent } from "../modals/add-new-credential/add-new-credential.component";
import { InfraCredential } from "src/app/core/models/infraCredential";
import { error } from "console";
import { ConfirmDialogComponent } from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DeploymentService } from "../../../core/services/deployment.service";
import { CloudProviderUi } from "../../../core/models/cloudProviderUi";
import { FormControl } from "@angular/forms";
import { distinctUntilChanged, debounceTime } from "rxjs";
import { NavigationService } from "src/app/core/services/navigation.service";
import { AuthenticationService } from "src/app/core/services/authentication.service";
import { UserRoleNames } from "src/app/core/models/users";

@Component({
  selector: "app-credential-list",
  templateUrl: "./credential-list.component.html",
  styleUrls: ["./credential-list.component.scss"],
})
export class CredentialListComponent implements OnInit {
  cloudProviders = [];
  infraCredentialList = [];
  filteredCredentials = [];
  filterText = new FormControl('');
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;
  constructor(
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private configEntityService: ConfigEntityService,
    private depService: DeploymentService,
    private navService: NavigationService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.configEntityService.sendActiveEntity('Credentials');
    this.navService.sendChildData('Credentials');
    this.navService.sendParentData(''); 
    this.getCloudProviderNameAndValue();
    this.getInfraCredData();
    this.filterText.valueChanges
      .pipe(distinctUntilChanged(), debounceTime(300))
      .subscribe((value) => {
        this.filteredCredentials = this.infraCredentialList.filter((cred) =>
          cred.friendlyName.toLowerCase().includes(value.toLowerCase()) ||
          cred.infrastructure.toLowerCase().includes(value.toLowerCase())
        );
      });
  }

  getCloudProviderNameAndValue() {
    this.depService.getAllCloudProvidersValueText().subscribe({
      next: (data: any) => {
        if (data) {
          this.cloudProviders = data;
        }
      },
      error: (error) => {
        this.snackBar.open("Failed to fetch cloud provider list, please try again.", "Ok", { duration: 5000 });
      }
    })
  }

  getInfraCredData() {
    this.configEntityService.getAllInfraCredentials().subscribe({
      next: (data) => {
        this.infraCredentialList = <InfraCredential[]>(
          JSON.parse(JSON.stringify(data))
        );
        this.filteredCredentials = this.infraCredentialList;
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  deleteInfra(friendlyName) {
    this.dialog.open(ConfirmDialogComponent, {
      autoFocus: false,
      disableClose: false,
      width: '25%',
      data: {
        titleMessage: "Delete Credential",
        bodyMessage: `Do you want to delete credential ${friendlyName}?`,
        cancelText: "Cancel",
        submitText: "Proceed"
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        this.configEntityService.deleteInfraCred(friendlyName).subscribe({
          next: (data) => {
            this.openSnackBar("Credential Deleted Successfully.")
            this.getInfraCredData()
          },
          error: (err) => {
            this.openSnackBar("Error while deleting credential. Check SyncHpc logs for more info.")
            //console.error(err);
          },
        });
      }
    })
  }

  updateInfraCred(friendlyName) {
    const dialogRef = this.dialog.open(AddNewCredentialComponent, {
      disableClose: true,
      width: "600px",
      data: { cloudValue: "", cloudName: "", updateForm: true, friendlyName: friendlyName },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.res) {
        this.openSnackBar("Credential updated successfully.")
        this.getInfraCredData()
      }
      else {
        if (res.data.len() != 0) {
          this.openSnackBar(res.data)
        }
        this.getInfraCredData()
      }
    });
  }

  addNewCredential(cloud: string, cloudValue) {
    const dialogRef = this.dialog.open(AddNewCredentialComponent, {
      disableClose: true,
      width: "600px",
      data: { cloudValue: cloudValue, cloudName: cloud, updateForm: false, friendlyName: ""},
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res.res) {
        this.openSnackBar("New credential added successfully")
        this.getInfraCredData()
      }
      else {
        if (res.data.len() != 0) {
          this.openSnackBar(res.data)
        }
        this.getInfraCredData()
      }
    });
  }

  openSnackBar(messeage: string, time: number = 5000) {
    this.snackBar.open(messeage, "Ok", {
      duration: time,
    });
  }
}
